import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import DatePicker from "react-date-picker";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import tccStyles from "../common/styles";

const BACKUP_MAX_DAYS = 30;

const styles = {
    calendar: {
        position: "fixed",
        color: tccStyles.productionColor.secondary
    },
    datepicker: {
        border: "thin solid",
        borderColor: tccStyles.productionColor.secondary
    }
};

class DownloadBackupButton extends Component {
    state = {
        show_dialog: false,
        dateValue: null,
        opInProgress: false,
        showSnackBar: false,
        error: false
    };

    handleClickOpen = () => {
        this.setState({ show_dialog: true });
    };

    handleCancel = () => {
        this.setState({ show_dialog: false, dateValue: null });
    };

    onChangeDate = event => {
        this.setState({ dateValue: event });
    };

    handleOk = () => {
        const { resource_id } = this.props;
        let date_calendar = new Date(this.state.dateValue).toLocaleDateString();
        let array_date = date_calendar.split("/");
        let date_format =
            array_date[2] + "-" + array_date[1] + "-" + array_date[0];
        this.setState({ opInProgress: true });
        myRestClient("UPDATE_NO_PREV", "installations", {
            id: resource_id,
            data: {
                action: "download_backup",
                backup_date: date_format
            }
        }).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    error: false,
                    show_dialog: false,
                    dateValue: null,
                    opInProgress: false
                });
            },
            () => {
                this.setState({
                    showSnackBar: true,
                    error: true,
                    show_dialog: false,
                    dateValue: null,
                    opInProgress: false
                });
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.download_backup_success`}
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.download_backup_error`}
                />
            </span>
        );
    }

    renderDialog() {
        const { classes = {}, className } = this.props;
        let minDate = new Date();
        minDate.setDate(minDate.getDate() - BACKUP_MAX_DAYS);
        let maxDate = new Date();
        maxDate.setDate(maxDate.getDate() - 1);

        return this.state.show_dialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.show_dialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText
                            resource_name={`resources.installations.actions.downloadBackup`}
                        />
                    </b>
                </DialogTitle>
                <DialogContent style={{ overflow: "visible" }}>
                    <div style={{ marginBottom: "0.5em" }}>
                        <TranslatedText
                            resource_name={`resources.installations.actions.download_backup_date_label`}
                        />
                    </div>
                    <DatePicker
                        onKeyDown={e => {
                            e.preventDefault();
                        }}
                        locale="it-IT"
                        onChange={this.onChangeDate}
                        value={this.state.dateValue}
                        minDate={minDate}
                        maxDate={maxDate}
                        calendarClassName={classnames(
                            "ra-delete-button",
                            classes.calendar,
                            className
                        )}
                        className={classnames(
                            "ra-delete-button",
                            classes.datepicker,
                            className
                        )}
                        format="dd/MM/yy"
                        clearIcon={null}
                    />
                </DialogContent>
                <DialogActions>
                    <div
                        align="center"
                        style={{
                            visibility: this.state.opInProgress
                                ? "visible"
                                : "hidden"
                        }}
                    >
                        {<CircularProgress />}
                    </div>
                    {!this.state.opInProgress && (
                        <div>
                            {" "}
                            <Button onClick={this.handleCancel} color="primary">
                                <TranslatedText
                                    resource_name={"ra.actions.cancel"}
                                />
                            </Button>
                            <Button
                                onClick={this.handleOk}
                                variant="contained"
                                color="secondary"
                                disabled={!this.state.dateValue}
                            >
                                <TranslatedText
                                    resource_name={"ra.actions.ok"}
                                />
                            </Button>
                        </div>
                    )}
                </DialogActions>
            </Dialog>
        ) : null;
    }

    render() {
        return (
            <span>
                <Button
                    color="primary"
                    target="_blank"
                    onClick={this.handleClickOpen}
                >
                    <TranslatedText
                        resource_name={`resources.installations.actions.downloadBackup`}
                    />
                </Button>
                {this.renderDialog()}
                {this.renderSnackBar()}
            </span>
        );
    }
}

export default withStyles(styles)(DownloadBackupButton);



// WEBPACK FOOTER //
// ./src/components/DownloadBackupButton.js